<template>
  <div class="ajaxForm">
    <h2>Add to box</h2>
    <p>
      Choose a box to add this file to. If you need a new box
      <a @click="createBox">create one</a>.
    </p>
    <table border="1">
      <tr>
        <th>Box id</th>
        <th>Created by</th>
        <th>Time</th>
        <th />
      </tr>
      <tr v-for="box in modifiedBoxes" :key="box.boxId">
        <td>
          <span class="boxId">{{ box.id }}</span>
        </td>
        <td>
          <EntityZ :entity="box.user" v-if="box.user" />
          <span v-if="!box.user">{{ box.userid }}</span>
        </td>
        <td>{{ box.timestamp | formatDateTime }}</td>
        <td>
          <v-btn @click="updateBox(box.id)" small>Add</v-btn>
        </td>
      </tr>
    </table>
    <hr />
    <v-btn @click="$emit('close-boxes')">Close</v-btn>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Boxes",
  components: {
    EntityZ,
  },
  computed: {
    modifiedBoxes() {
      if (!this.boxes) {
        return undefined;
      }
      return this.boxes.map((b) => {
        const user = this.entities ? this.entities[b.userid] : undefined;
        return { ...b, user };
      });
    },
  },
  data() {
    return { boxes: null, entities: null };
  },
  methods: {
    async fetchBoxesUnfinished() {
      const response = await nbmlaw.get(`/cors/admin/file/boxes/unfinished`);
      // console.log(response.data);
      this.boxes = response.data;
    },
    async fetchEntities() {
      const response = await nbmlaw.get(
        `/cors/admin/file/boxes/unfinished/users`
      );
      // console.log(response.data);
      this.entities = response.data;
    },
    async createBox() {
      if (
        confirm(
          "WARNING: this will create a new box and move the file into it.  Are you sure?"
        )
      ) {
        await nbmlaw.post(
          `/cors/admin/file/files/${this.$route.params.id}/box`,
          null
        );
        this.$emit("update");
      }
    },
    async updateBox(boxId) {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/box/${boxId}`,
        null
      );
      this.$emit("closeBoxes");
      this.$emit("update");
    },
    update() {
      this.fetchBoxesUnfinished();
      this.fetchEntities();
    },
  },
  watch: {
    "$route.params.id": function () {
      this.update();
    },
  },
  created() {
    this.update();
  },
};
</script>

<style>
</style>
